// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"726031b7","71":"27f25d88","133":"9140a8fe","453":"15359044","555":"f0b9e3cb","744":"87d899f7","788":"52bb04dd","824":"277d47f8","962":"de073456"}[chunkId] + ".chunk.js";
};